/* eslint-disable jsx-a11y/no-static-element-interactions,react/forbid-prop-types */
import PropTypes from 'prop-types';
import React from 'react';

const BasicContainer = ({
  children,
  className = '',
  onClick = () => {},
  rounded = 'rounded-3',
  style = {},
}) => (
  <div
    style={style}
    className={`container ${className} ${rounded} ${className.indexOf('p-') === -1 ? 'p-4' : ''} `}
    onClick={onClick}
    onKeyDown={onClick}
    role={onClick ? 'button' : 'none'}
    tabIndex={-1}>
    {children}
  </div>
);
export default BasicContainer;

BasicContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  className: PropTypes.string,
  rounded: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};
